


























import Vue from 'vue';
import helpers from '@/lib/helpers';
import Fetch from '@/lib/fetch.ts';
import LoadingSpinner from '@/components/LoadingSpinner.vue';
import { Post, PostData } from '@/lib/types.ts';
import {Route} from 'vue-router';

export default Vue.extend({
    data() {
        return {
            posts: [] as Post[],
            offset: 0,
            amount: 10,
            maxPosts: 0,
            loaded: false,
            helpers,
        };
    },
    components: {LoadingSpinner},
    beforeDestroy(): void {
        window.removeEventListener('scroll', async (e: Event) => {
            this.requestIfNeeded(e);
        });
    },
    async beforeRouteEnter(to: Route, from: Route, next: any) {
        next(async (vm: any) => {
            const postQuery: PostData = await vm.requestPosts();
            vm.posts = postQuery.posts.filter((p) => p.visible);
            vm.maxPosts = postQuery.amount;
            vm.loaded = true;
        });
    },
    async created(): Promise<void> {
        window.addEventListener('scroll', async (e: Event) => {
            this.requestIfNeeded(e);
        });
    },
    methods: {
        async requestPosts(): Promise<PostData> {
            // posts get sorted by index on the backend
            return await Fetch.get(`/api/blogposts/${this.offset}:${this.amount}`);
        },
        async requestIfNeeded(e: Event) {
            if (e && e.target) {
                const target: HTMLDocument = e.target as HTMLDocument;
                const scrolled: number = target.documentElement.scrollTop;
                const docHeight: number = target.documentElement.offsetHeight - window.innerHeight;
                const scrollPercent = scrolled / docHeight;
                if (scrollPercent > 0.60) {
                    await this.loadPosts();
                }
            }
        },
        async loadPosts(): Promise<void> {
            this.offset += this.amount;
            if (this.offset <= this.maxPosts) {
              const postQuery: PostData = await this.requestPosts();
              postQuery.posts.forEach((post) => this.posts.push(post));
              this.maxPosts = postQuery.amount;
            }
        },
    },
});
